import React from 'react';
import { StoreI18n, StoreSettings } from '../../../../Types/StoreTypes';
import Input from '../../../Utility/FormElements/Input';
import Checkbox from '../../../Utility/FormElements/Checkbox';
import { Button } from '../../../Utility/Button';

interface InstanceSettingsProps {
    SettingsActions: any;
    i18n: StoreI18n['i18n'];
    Currentsettings: StoreSettings;
}

function InstanceSettings({ SettingsActions, i18n, Currentsettings }: InstanceSettingsProps) {
    return (
        <div className="w-full flex gap-5 flex-col">
            <h4>{i18n.translate({ id: 'instanceSettings', sourceName: 'Settings' })}</h4>

            <label htmlFor="licences" className="flex flex-col gap-2">
                {i18n.translate({ id: 'licences', sourceName: 'Settings' })}
                <Input
                    inputType="number"
                    value={Currentsettings.licences}
                    onChange={(licences) => SettingsActions.updateCurrentSettings({ licences: licences })}
                    inputProps={{ min: 0, step: 1 }}
                    id="licences"
                />
            </label>

            <label htmlFor="apiKeyLicences" className="flex flex-col gap-2">
                {i18n.translate({ id: 'apiKeyLicences', sourceName: 'Settings' })}
                <Input
                    inputType="number"
                    value={Currentsettings.apiKeyLicences}
                    onChange={(apiKeyLicences) =>
                        SettingsActions.updateCurrentSettings({ apiKeyLicences: apiKeyLicences })
                    }
                    inputProps={{ min: 0, step: 1 }}
                    id="apiKeyLicences"
                />
            </label>

            <label>
                {i18n.translate({ id: 'supportMailAddress', sourceName: 'Settings' })}
                <Input
                    inputType="string"
                    value={Currentsettings.supportMailAddress}
                    onChange={(value) => SettingsActions.updateCurrentSettings({ supportMailAddress: value })}
                />
            </label>

            <label>
                {i18n.translate({ id: 'accountId', sourceName: 'Settings' })}
                <Input
                    inputType="string"
                    value={Currentsettings.accountId}
                    onChange={(value) => SettingsActions.updateCurrentSettings({ accountId: value })}
                />
            </label>

            <div className="mt-3 flex flex-col gap-1 mb-3 prompt-functions-container">
                <label className="flex items-center space-x-3 cursor-pointer opacity-100">
                    <div className="relative h-6 w-6">
                        <Checkbox
                            checked={Currentsettings.demo}
                            onChange={() =>
                                SettingsActions.updateCurrentSettings({
                                    demo: !Currentsettings.demo,
                                })
                            }
                        />
                    </div>
                    <span>{i18n.translate({ id: 'demo', sourceName: 'Settings' })}</span>
                </label>
                <label className="flex items-center space-x-3 cursor-pointer opacity-100">
                    <div className="relative h-6 w-6">
                        <Checkbox
                            checked={Currentsettings.betaActive}
                            onChange={() =>
                                SettingsActions.updateCurrentSettings({
                                    betaActive: !Currentsettings.betaActive,
                                })
                            }
                        />
                    </div>
                    <span>{i18n.translate({ id: 'betaActive', sourceName: 'Settings' })}</span>
                </label>

                <label className="flex items-center space-x-3 cursor-pointer opacity-100">
                    <div className="relative h-6 w-6">
                        <Checkbox
                            checked={Currentsettings.features.documentUpload}
                            onChange={() =>
                                SettingsActions.updateCurrentSettings({
                                    features: {
                                        ...Currentsettings.features,
                                        documentUpload: !Currentsettings.features.documentUpload,
                                    },
                                })
                            }
                        />
                    </div>
                    <span>
                        {i18n.translate({
                            id: 'documentUpload',
                            sourceName: 'Settings',
                        })}
                    </span>
                </label>

                <label className="flex items-center space-x-3 cursor-pointer opacity-100">
                    <div className="relative h-6 w-6">
                        <Checkbox
                            checked={Currentsettings.prePaidNotifications}
                            onChange={() =>
                                SettingsActions.updateCurrentSettings({
                                    prePaidNotifications: !Currentsettings.prePaidNotifications,
                                })
                            }
                        />
                    </div>
                    <span>{i18n.translate({ id: 'prePaidNotifications', sourceName: 'Settings' })}</span>
                </label>

                <label className="flex items-center space-x-3 cursor-pointer opacity-100">
                    <div className="relative h-6 w-6">
                        <Checkbox
                            checked={Currentsettings.prePaidActive}
                            onChange={() =>
                                SettingsActions.updateCurrentSettings({
                                    prePaidActive: !Currentsettings.prePaidActive,
                                })
                            }
                        />
                    </div>
                    <span>{i18n.translate({ id: 'prePaidActive', sourceName: 'Settings' })}</span>
                </label>

                <label className="flex items-center space-x-3 cursor-pointer opacity-100">
                    <div className="relative h-6 w-6">
                        <Checkbox
                            checked={Currentsettings.selfUpdateActive}
                            onChange={() =>
                                SettingsActions.updateCurrentSettings({
                                    selfUpdateActive: !Currentsettings.selfUpdateActive,
                                })
                            }
                        />
                    </div>
                    <span>{i18n.translate({ id: 'selfUpdateActive', sourceName: 'Settings' })}</span>
                </label>
            </div>

            <div className="mt-5 text-right">
                <Button onClick={SettingsActions.handleUpdateSettings}>
                    {i18n.translate({ id: 'save', sourceName: 'Main' })}
                </Button>
            </div>
        </div>
    );
}

export default InstanceSettings;
